module.exports = __webpack_public_path__ + "media/images/icons/filled/sound-b1d31d2b80973ddf3ef7160cd92d1e98.svg";